import { LoadingButton } from '@mui/lab';
import { Box, Button } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import { FormProvider, RHFTextField } from 'src/components/hook-form';
import { SUBSCRIBE_PACKAGE_TYPE_LIST } from 'src/constants/queryKeys';
import { networkCreateSubscribePackageType, networkUpdateSubscribePackageType } from 'src/network/subscribe-package/subscribe-package-type';
import useFormsModalStore from 'src/store/forms';
import { getDefaultValues } from './defaultValues';

const SubscribePackageTypeForm = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const { modal, closeModal } = useFormsModalStore();

  const subscribePackageDetails = modal?.data;
  const isEditMode = !!subscribePackageDetails;

  const landingDetails = modal?.data;
  const defaultValues = getDefaultValues(landingDetails);

  const methods = useForm({
    // resolver: yupResolver(schema), // todo schema
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (values, event) => {
    const PAYLOAD = {
      ...values,
    };

    try {
      if (isEditMode) {
        const res = await networkUpdateSubscribePackageType(landingDetails?.SubscribePackageTypeID, PAYLOAD);
        if (res.data?.items?.ResultID !== -1) {
          enqueueSnackbar('آیتم موردنظر با موفقیت ویرایش شد');
          if (event.nativeEvent.submitter.name === 'save') {
            closeModal();
            reset();
            await queryClient.invalidateQueries({ queryKey: [SUBSCRIBE_PACKAGE_TYPE_LIST] });
          }
        } else {
          enqueueSnackbar('با مشکل مواجه شد !', { variant: 'error' });
        }
      } else {
        const res = await networkCreateSubscribePackageType(PAYLOAD);
        if (res.data?.items?.ResultID !== -1) {
          enqueueSnackbar('آیتم موردنظر با موفقیت ایجاد شد');
          if (event.nativeEvent.submitter.name === 'save') {
            closeModal();
            await queryClient.invalidateQueries({ queryKey: [SUBSCRIBE_PACKAGE_TYPE_LIST] });
          }
          reset();
        } else {
          enqueueSnackbar('با مشکل مواجه شد !', { variant: 'error' });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Box
        sx={{
          display: 'grid',
          columnGap: 2,
          rowGap: 3,
          gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
          mt: 2,
        }}
      >
        <RHFTextField name="SubscribePackageTypeLable" type="text" label="عنوان" />
      </Box>
      <div className="flex items-center gap-4 mt-6">
        <LoadingButton type="submit" variant="contained" name="save" loading={isSubmitting}>
          ذخیره
        </LoadingButton>
        <LoadingButton type="submit" variant="contained" color="info" name="saveAndContinue" loading={isSubmitting}>
          {isEditMode ? 'ذخیره و ادامه ویرایش' : 'ذخیره و ایجاد بعدی'}
        </LoadingButton>
        <Button onClick={closeModal} variant="contained" color="error">
          انصراف
        </Button>
      </div>
    </FormProvider>
  );
};

export default SubscribePackageTypeForm;
